import React, { useEffect } from 'reactn'
import { graphql, Link, StaticQuery } from 'gatsby'
import IngmarsonSearch from "../components/search/ingmarsonSearch"
import Auth from '@aws-amplify/auth'
import { navigate } from "@reach/router"
import { isLoggedIn, signInRequired, setUserID } from "../components/auth/auth"
import { CartSidebar } from "../components/CheckoutPage/cartSidebar"
import CookieConsent, { getCookieConsentValue } from "react-cookie-consent"
import { loadStripe } from '@stripe/stripe-js'
import { useOnlineStatus } from '../components/utils/onlineStatus'

const aa = require('search-insights')

const cookieName = 'ingCookieConsent'
const appId = process.env.GATSBY_ALGOLIA_APP_ID;
const searchKey = process.env.GATSBY_ALGOLIA_SEARCH_KEY;

const CommonState = ({ globalState, pageContext, location, children }) => {
  const { store, updateGlobal } = globalState
  const stripeRef = React.useRef(null)

  if (location && location.href.includes("#checkout")) {
    updateGlobal({
      checkoutOpen: true,
      cartOpen: true,
    })
  }

  const isSSR = typeof window === "undefined"
  const isOnline = useOnlineStatus();

  const getData = async () => {
    window
      .fetch("https://geolocation-db.com/json/")
      .then(res => {
        return res.json();
      })
      .then(data => {
        updateGlobal({ ip: data.IPv4 })
        try {
          (async () => {
            if (stripeRef.current) {
              stripeRef.current.createRadarSession().then(function (result) {
                if (result.error) {
                } else {
                  if (result.radarSession) {
                    updateGlobal({
                      ip: data.IPv4,
                      radarID: result.radarSession.id
                    })
                  }
                }
              });
            }
          })()
        } catch (e) {
        }
      }).catch(e => {
        updateGlobal({ ip: "" })
        try {
          (async () => {
            if (stripeRef.current) {
              stripeRef.current.createRadarSession().then(function (result) {
                if (result.error) {
                } else {
                  if (result.radarSession) {
                    updateGlobal({
                      ip: "",
                      radarID: result.radarSession.id
                    })
                  }
                }
              });
            }
          })()
        } catch (e) {
        }
      })

  }



  if (!isSSR) {
    window.dataLayer = window.dataLayer || [];
  }
  function gtag() {
    window.dataLayer.push(arguments);
  }


  useEffect(() => {
    if (isOnline) {
      getData()
    }
  }, [isOnline])

  // Load Stripe once when browser loads
  useEffect(() => {
    (async () => {
      if (!stripeRef.current) {
        try {
          stripeRef.current = await loadStripe(process.env.GATSBY_STRIPE_API_KEY);
          updateGlobal({
            stripe: stripeRef.current
          });
        } catch (error) {
          console.log('Error loading Stripe:', error);
        }
      }
    })();
  }, []); // Only run once on mount
  useEffect(() => {
    async function checkAuth() {
      if (!isLoggedIn() && (!signInRequired || (signInRequired && !location.pathname.startsWith('/admin/login')))) {
        const anonymousUser = await Auth.currentCredentials()
        setUserID(anonymousUser.identityId)
      } else {
        if (isLoggedIn()) {
        } else {
        }
      }
    }

    checkAuth()
  }, [location && location.pathname])






  useEffect(() => {
    const cookieEnabled = getCookieConsentValue(cookieName)
    const trackContent = cookieEnabled === 'true' ? "granted" : "denied"
    gtag('set', 'url_passthrough', true);
    gtag("consent", "default", {
      ad_storage: trackContent,
      ad_user_data: trackContent,
      ad_personalization: trackContent,
      analytics_storage: trackContent,
      functionality_storage: "granted",
      personalization_storage: trackContent,
      security_storage: "granted",
      wait_for_update: 500
    });

    aa("init", {
      appId: appId,
      apiKey: searchKey,
    });


  }, [])

  if (typeof window !== 'undefined' && signInRequired() && !isLoggedIn() && location.pathname !== `/admin/login` && location.pathname !== `/admin/signup`) {
    navigate("/admin/login")
    return null
  }



  return (

    <>
      <IngmarsonSearch pageContext={pageContext} location={location} globalState={globalState}>
        {children}
      </IngmarsonSearch>
      <CartSidebar location={location} globalState={globalState} />

      <CookieConsent
        location="bottom"
        acceptOnScroll={true}
        acceptOnScrollPercentage={50}
        onAccept={(acceptedByScrolling) => {
          gtag("consent", "update", {
            ad_storage: "granted",
            analytics_storage: "granted",
            functionality_storage: "granted",
            personalization_storage: "granted",
            security_storage: "granted",
            wait_for_update: 500
          });
        }}
        buttonText="OK"
        cookieName={cookieName}
        style={{ background: "#000000" }}
        buttonStyle={{ background: "white", color: "#000000", fontWeight: 600, fontSize: "14px" }}
        expires={720}
      >We use cookies for a better shopping experience.{" "}
        <span style={{ fontSize: "10px" }}>By accepting, you agree to our <Link to='/privacy'>privacy policy</Link>. </span>
      </CookieConsent>

    </>

  )
}

export default props => (
  <StaticQuery
    query={graphql`
        query SnipcartInfoQuery {
            site {
              siteMetadata {
                rebuildDate
                apiEndpoint
              }
            }
          }
        `}
    render={({ site }) => <CommonState snipcartData={site.siteMetadata} {...props} />}
  />
)

